import React from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { CustomSelect, ImageWithPreview, Modal } from 'src/components';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import TextField from 'src/components/text-field';
import Button from 'src/components/button';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchTable } from 'src/redux/action/table.action';
import { useDispatch } from 'react-redux';
import { fetchFloor } from 'src/redux/action/floor.action';
import { DefaultSelect } from 'src/components/defaultSelect';
import DiscountCustomSelect from 'src/components/DiscountSelect/DiscountCustomSelect';
import { AiOutlinePlus } from 'react-icons/ai';
import { BiErrorCircle } from 'react-icons/bi';
import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  setIsEdit: (val: boolean) => void;
  setEditId: (val: string) => void;
  isEdit: boolean;
  editId: string;
  editFloorData: any;
}

type floorsPostValue = {
  name: string;
  tables: any;
};

// form validation
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Area Name must a at least 3 character long')
    .required('Area Name is required'),
  // tables: Yup.array()
  //   .min(1, 'Please select at least one option')
  //   .required('Table is required'),
});

const AddFloor: React.FC<IProps> = ({
  showModal,
  handleModal,
  editId,
  isEdit,
  setEditId,
  setIsEdit,
  editFloorData,
}) => {
  const dispatch = useDispatch();
  const [selectedFloorAssign, setSelectedFloorAssign] = React.useState('');
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const { tableData } = useSelector(({ tableData }: RootState) => tableData);

  React.useEffect(() => {
    if (tableData.length > 0) return;
    dispatch(fetchTable() as any);
  }, [dispatch]);

  const intValues = {
    id: isEdit ? editFloorData?.id : '',
    name: isEdit ? editFloorData?.name : '',
    tables: isEdit ? editFloorData?.tables : [],
  };

  const handleSubmit = async (val: floorsPostValue) => {
    const editPayload = {
      ...val,
    };
    try {
      if (editId) {
        await Service.put('/floors/edit', editPayload);
      } else {
        await Service.post('/floors/create', val);
      }
      handleModal();
      toastAlert(
        'success',
        `${val?.name} is successfully ${editId ? 'edited' : 'added'}`
      );
      dispatch(fetchFloor() as any);
      setIsEdit(false);
      setEditId('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
      setIsEdit(false);
      setEditId('');
    }
  };

  const handleSelectOptionsChange = (newSelectOptions: any) => {
    setSelectedFloorAssign(newSelectOptions.label);
  };

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={isEdit ? 'Edit Area' : 'Add Area'}
          onClick={handleModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ isSubmitting, isValid }) => (
                <Form className="mt-5">
                  <TextField label="Area Name" name="name" />
                  <Field
                    name="tables"
                    className="mt-3"
                    options={tableData}
                    component={DiscountCustomSelect}
                    defaultValue={
                      isEdit &&
                      editFloorData?.tables.map((item: any) => ({
                        label: item.name,
                        value: item.id,
                      }))
                    }
                    isMulti={true}
                    label="Table"
                    placeholder={'Select a table'}
                    onChangeCallback={handleSelectOptionsChange}
                  />

                  <div className="flex items-center justify-end mt-10">
                    <Button
                      text={isEdit ? 'edit area' : 'Add Area'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddFloor);
